import React, { useState } from "react"
import Select from 'react-select'
import {
    DateTime
} from 'luxon'

import { DateRangePicker } from "../../../../../../mogul/components/DashboardGraph"
import useLocations from "../../../../../../mogul/hooks/useLocations"

// this was originally built specifically for Divine and Lead Concepts, so it works well for those 3 tables.

export interface OriginalDataObjectFilterObject {
    selectedLocationUniqueIds: string[],
    selectedPreneedOptions: string[],
    onlyUnSyncedWith360: boolean,
    showAllLeadsEvenIfLocationIsIgnored: boolean,
    startingUnixTimestamp?: number,
    endingUnixTimestamp?: number
}

export default function OriginalDataObjectFilterList({
    onCancel,
    onReset,
    currentFilterObject,
    onApplyFilter,
    isFilterChild = false,
    displayShowAllLeadsToggle = false
}: {
    onCancel: () => void,
    onReset: () => void,
    currentFilterObject: OriginalDataObjectFilterObject | null,
    onApplyFilter: (filterObject: OriginalDataObjectFilterObject) => void,
    isFilterChild?: boolean,
    displayShowAllLeadsToggle?: boolean
}) {

    const {
        locations,
        loading: loadingLocations
    } = useLocations()

    const [selectedLocationUniqueIds, setSelectedOrgIds] = useState<string[]>(currentFilterObject ? currentFilterObject.selectedLocationUniqueIds : [])
    const [selectedPreneedOptions] = useState<string[]>(currentFilterObject ? currentFilterObject.selectedPreneedOptions : [])
    const [onlyUnSyncedWith360, setOnlyUnSyncedWith360] = useState(currentFilterObject ? currentFilterObject.onlyUnSyncedWith360 : false)
    const [showAllLeadsEvenIfLocationIsIgnored, setShowAllLeadsEvenIfLocationIsIgnored] = useState(currentFilterObject ? currentFilterObject.showAllLeadsEvenIfLocationIsIgnored : false)

    const [startingUnixTimestamp, setStartingUnixTimestamp] = React.useState(
        currentFilterObject?.startingUnixTimestamp || Math.floor(DateTime.local().setZone('America/Chicago').minus({ days: 365 }).startOf('day').toSeconds())
    )

    const [endingUnixTimestamp, setEndingUnixTimestamp] = React.useState(
        currentFilterObject?.endingUnixTimestamp || Math.floor(DateTime.local().setZone('America/Chicago').toSeconds())
    )


    return (
        <div>
            {!isFilterChild && <>
                <div className='px-7 py-5'>
                    <div className='fs-5 text-dark fw-bolder'>Filter List</div>
                </div>
                <div className='separator border-gray-200'></div>
            </>}

            <div className={isFilterChild ? `` : 'px-7 py-5'}>

                <div className='mb-5'>
                    <label className='form-label fw-bold'>
                        Funeral Home
                    </label>
                    <div>
                        <Select
                            options={[
                                { value: '', label: '-All Funeral Homes-' },
                                ...locations.map((option) => {
                                    return {
                                        value: `${option.unique_identifier}`,
                                        label: option.name
                                    }
                                })]}
                            onChange={(selectedOption) => {
                                setSelectedOrgIds(selectedOption ? selectedOption.map((x) => x.value) : [])
                            }}
                            isMulti
                            filterOption={(option, searchValue) => {
                                const words = searchValue.toLowerCase().split(' ');
                                return words.every(word => option.label.toLowerCase().includes(word));
                            }}
                            value={locations.filter(x => (selectedLocationUniqueIds || []).includes(`${x.unique_identifier}`)).map((option) => {
                                return {
                                    value: `${option.unique_identifier}`,
                                    label: option.name
                                }
                            })}
                            isDisabled={loadingLocations || isFilterChild}
                        />
                    </div>
                </div>

                {!isFilterChild && <>
                    <div className='mb-5'>
                        <label className='form-label fw-bold'>Only those un-synced with 360:</label>
                        <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                            <input
                                className='form-check-input'
                                type='checkbox'
                                name='notifications'
                                onChange={(e) => setOnlyUnSyncedWith360(e.target.checked)}
                                checked={onlyUnSyncedWith360}
                            />
                            <label className='form-check-label'>Enabled</label>
                        </div>
                    </div>
                </>}

                <div className="mb-5">
                    <label className='form-label fw-bold'>Date Range</label>
                    <div style={{ maxWidth: 420 }}>
                        <DateRangePicker
                            startingUnixTimestamp={startingUnixTimestamp}
                            setStartingUnixTimestamp={setStartingUnixTimestamp}
                            endingUnixTimestamp={endingUnixTimestamp}
                            setEndingUnixTimestamp={setEndingUnixTimestamp}
                            hideUpdateButton
                            disabled={!!isFilterChild}
                        />
                    </div>
                </div>


                {displayShowAllLeadsToggle && <>
                    <div className='mb-5'>
                        <label className='form-label fw-bold'>Show all leads, even if location has been ignored:</label>
                        <div className='form-check form-switch form-switch-sm form-check-custom form-check-solid'>
                            <input
                                className='form-check-input'
                                type='checkbox'
                                name='notifications'
                                onChange={(e) => setShowAllLeadsEvenIfLocationIsIgnored(e.target.checked)}
                                checked={showAllLeadsEvenIfLocationIsIgnored}
                            />
                            <label className='form-check-label'>Enabled</label>
                        </div>
                    </div>
                </>}

                {isFilterChild && <div className="mb-5">
                    <div className="alert alert-info py-2 px-3 mb-0" style={{ fontSize: 14 }}>
                        <strong>Note:</strong> Filtering must be changed before exporting, to ensure the correct leads are exported.
                    </div>
                </div>}

                {!isFilterChild && <>
                    <div className='d-flex justify-content-end'>
                        <button
                            type='button'
                            className='btn btn-sm btn-light btn-active-light-primary me-2'
                            onClick={() => onReset()}
                        >
                            Reset
                        </button>
                        <button
                            type='button'
                            className='btn btn-sm btn-light btn-active-light-primary me-2'
                            onClick={() => onCancel()}
                        >
                            Cancel
                        </button>
                        <button
                            type='button'
                            className='btn btn-sm btn-primary'
                            onClick={() => onApplyFilter({
                                selectedLocationUniqueIds: selectedLocationUniqueIds,
                                selectedPreneedOptions,
                                onlyUnSyncedWith360: onlyUnSyncedWith360,
                                showAllLeadsEvenIfLocationIsIgnored: showAllLeadsEvenIfLocationIsIgnored,
                                startingUnixTimestamp: startingUnixTimestamp,
                                endingUnixTimestamp: endingUnixTimestamp
                            })}
                        >
                            Apply
                        </button>
                    </div>
                </>}
            </div>
        </div>
    )
}